export const authType = process.env.ENVIRON;
